<button type="button" class="btn fetchData app-back-btn" (click)="onBack()">
  <mat-icon>{{ icon }}</mat-icon>
  <span>{{ label }}</span>
</button>
